import axios from 'axios'

import { ROUTES } from 'settings/settings'
import { LogService } from 'services/Log/Log'

export async function getUsers() {
  try {
    const { data } = await axios({
      method: 'GET',
      url: `/${ROUTES.listUsers}`,
      baseURL: process.env.REACT_APP_USER_API,
    })

    return { data }
  } catch (error: any) {
    LogService.error({ message: 'getUsers', error })
    return { data: null, error: error.response?.data?.message }
  }
}
